(ns frontend.view.grid.exit-opportunities-grid.db
  (:require [frontend.db :as app-db]
            [reagent.core :as r]))

(defonce exit-opportunities (r/cursor app-db/views [:exit-opportunities-grid]))
(defonce modal-state (r/cursor exit-opportunities [:modals]))
(defonce grid-entities (r/cursor exit-opportunities [:grid-entities]))
(defonce view-settings (r/cursor exit-opportunities [:view-settings]))
(defonce exit-opportunity-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

;;kanban related definitions
(defonce kanban (r/cursor exit-opportunities [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor exit-opportunities [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor exit-opportunities [:schema]))
